// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filters beside the list on wide screens, foldable panel above it on phones/tablets */
.alarms-layout {
  box-sizing: content-box;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 12px 32px;
}
@media (min-width: 768px) {
  .alarms-layout {
    padding: 24px 20px 40px;
  }
}
@media (min-width: 992px) {
  .alarms-layout {
    display: grid;
    grid-template-columns: 300px minmax(0, 1fr);
    align-items: start;
    gap: 20px;
  }
}

.alarms-results {
  min-width: 0;
}

.alarms-filters {
  margin-bottom: 16px;
  border-radius: 14px;
  background: var(--ion-background-color, #fff);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
  /* Phones/tablets: header button that folds the panel */
}
.alarms-filters__toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.alarms-filters__toggle:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: -2px;
}
.alarms-filters__toggle-icon {
  flex-shrink: 0;
  font-size: 20px;
  color: var(--ion-color-primary);
}
.alarms-filters__toggle-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.alarms-filters__toggle-title {
  font-size: 15px;
  font-weight: 600;
}
.alarms-filters__toggle-summary {
  font-size: 13px;
  color: var(--ion-color-medium-shade);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.alarms-filters__chevron {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-medium);
  transition: transform 0.2s ease;
}
.alarms-filters--open .alarms-filters__chevron {
  transform: rotate(180deg);
}
.alarms-filters {
  /* Title only in the side column */
}
.alarms-filters__title {
  display: none;
}
.alarms-filters__body {
  display: none;
  padding: 4px 16px 16px;
}
.alarms-filters--open .alarms-filters__body {
  display: block;
}
.alarms-filters__actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);
}
.alarms-filters__actions ion-button {
  flex: 1;
  margin: 0;
  height: 42px;
  --border-radius: 10px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: normal;
}
.alarms-filters {
  /* Wide screens: always open, sticky side column */
}
@media (min-width: 992px) {
  .alarms-filters {
    position: sticky;
    top: 16px;
    margin-bottom: 0;
    padding: 18px;
  }
  .alarms-filters__toggle {
    display: none;
  }
  .alarms-filters__title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 0 16px;
    font-size: 17px;
    font-weight: 600;
  }
  .alarms-filters__title ion-icon {
    font-size: 20px;
    color: var(--ion-color-primary);
  }
  .alarms-filters__body {
    display: block;
    padding: 0;
  }
  .alarms-filters ::ng-deep .alarm-filters {
    grid-template-columns: minmax(0, 1fr);
  }
  .alarms-filters__actions {
    flex-direction: column-reverse;
  }
}

/* Alarms: white rounded card, one row per alarm, details unfold below */
.alarm-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 14px;
  overflow: hidden;
  background: var(--ion-background-color, #fff);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
}
@media (max-width: 767px) {
  .alarm-list {
    margin: 0 -12px;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }
}

.alarm-item + .alarm-item {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}
.alarm-item__head {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.alarm-item__head:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.alarm-item__head:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: -2px;
}
.alarm-item--open .alarm-item__head {
  background: rgba(var(--ion-color-primary-rgb), 0.04);
}
.alarm-item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: #fff;
}
.alarm-item__icon ion-icon {
  font-size: 22px;
}
.alarm-item__main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}
.alarm-item__title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.alarm-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
}
.alarm-item__meta-entry {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.alarm-item__meta-entry ion-icon {
  font-size: 15px;
}
.alarm-item {
  /* State pill: tinted version of the icon colour */
}
.alarm-item__state {
  flex-shrink: 0;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.alarm-item__state.danger-background {
  color: var(--ion-color-danger-shade);
  background: rgba(var(--ion-color-danger-rgb), 0.12);
}
.alarm-item__state.warning-background {
  color: var(--ion-color-warning-shade);
  background: rgba(var(--ion-color-warning-rgb), 0.16);
}
.alarm-item__state.primary-background {
  color: var(--ion-color-primary-shade);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
.alarm-item__state.dark-background, .alarm-item__state.default-background {
  color: var(--ion-color-step-750, #404040);
  background: rgba(var(--ion-color-medium-rgb), 0.14);
}
.alarm-item__chevron {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--ion-color-medium);
  transition: transform 0.2s ease;
}
.alarm-item--open .alarm-item__chevron {
  transform: rotate(180deg);
}
.alarm-item {
  /* Expanded details: label/value pairs, side by side on wide screens */
}
.alarm-item__details {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
  margin: 0;
  padding: 4px 16px 16px 72px;
}
@media (min-width: 576px) {
  .alarm-item__details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 575px) {
  .alarm-item__details {
    padding-left: 16px;
  }
}
.alarm-item--skeleton {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
}
.alarm-item--skeleton .skeleton-circle {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 50%;
}
.alarm-item--skeleton .skeleton-lines {
  flex: 1;
}
.alarm-item--skeleton .skeleton-lines ion-skeleton-text {
  height: 12px;
  margin: 6px 0;
  border-radius: 6px;
}
.alarm-item {
  /* Phones: the state pill moves under the text, to keep the title readable */
}
@media (max-width: 575px) {
  .alarm-item__head {
    flex-wrap: wrap;
  }
  .alarm-item__main {
    flex-basis: calc(100% - 42px - 14px - 18px - 14px);
  }
  .alarm-item__state {
    order: 5;
    margin-left: 56px;
  }
}

.alarm-detail {
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(var(--ion-color-medium-rgb), 0.07);
}
.alarm-detail dt {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: var(--ion-color-medium-shade);
}
.alarm-detail dt ion-icon {
  font-size: 15px;
  color: var(--ion-color-primary);
}
.alarm-detail dd {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  overflow-wrap: anywhere;
}

/* Icon colour by alarm state */
.alarm-item__icon.dark-background {
  background-color: var(--ion-color-dark);
}
.alarm-item__icon.warning-background {
  background-color: var(--ion-color-warning);
}
.alarm-item__icon.danger-background {
  background-color: var(--ion-color-danger);
}
.alarm-item__icon.primary-background {
  background-color: var(--ion-color-primary);
}
.alarm-item__icon.default-background {
  background-color: var(--ion-color-medium);
}

/* "Reset filters": outlined when it can be used, faded and dashed when there is nothing to reset */
.reset-button {
  --color: var(--ion-color-step-800, #333);
  --border-color: rgba(var(--ion-color-medium-rgb), 0.45);
  --border-width: 1px;
  --background-hover: rgba(var(--ion-color-medium-rgb), 0.1);
  --background-hover-opacity: 1;
}
.reset-button.button-disabled {
  opacity: 1;
  --color: var(--ion-color-medium);
  --border-color: rgba(var(--ion-color-medium-rgb), 0.3);
  --border-style: dashed;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/alarms-history-list/alarms-history-list.component.scss","webpack://./src/components/general%20components/alarms-history-list/alarms-history-list.component.scss"],"names":[],"mappings":"AAAA,uFAAA;AACA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;ACCF;ADCE;EANF;IAOI,uBAAA;ECEF;AACF;ADAE;EAVF;IAWI,aAAA;IACA,2CAAA;IACA,kBAAA;IACA,SAAA;ECGF;AACF;;ADAA;EACE,YAAA;ACGF;;ADAA;EACE,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,yDAAA;EAEA,uDAAA;ACEF;ADDE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ACGJ;ADDI;EACE,0DAAA;EACA,oBAAA;ACGN;ADCE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;ACCJ;ADEE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;ACAJ;ADGE;EACE,eAAA;EACA,gBAAA;ACDJ;ADIE;EACE,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ACFJ;ADKE;EACE,cAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;ACHJ;ADME;EACE,yBAAA;ACJJ;ADzDA;EAgEE,kCAAA;ACJF;ADKE;EACE,aAAA;ACHJ;ADME;EACE,aAAA;EACA,sBAAA;ACJJ;ADOE;EACE,cAAA;ACLJ;ADQE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6DAAA;ACNJ;ADQI;EACE,OAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;ACNN;ADtFA;EAgGE,kDAAA;ACPF;ADQE;EAjGF;IAkGI,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;ECLF;EDOE;IACE,aAAA;ECLJ;EDQE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;ECNJ;EDQI;IACE,eAAA;IACA,+BAAA;ECNN;EDUE;IACE,cAAA;IACA,UAAA;ECRJ;EDYE;IACE,qCAAA;ECVJ;EDaE;IACE,8BAAA;ECXJ;AACF;;ADeA,wEAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,yDAAA;ACZF;ADcE;EATF;IAUI,eAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;ECXF;AACF;;ADeE;EACE,6DAAA;ACZJ;ADeE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;ACbJ;ADeI;EACE,oDAAA;ACbN;ADgBI;EACE,0DAAA;EACA,oBAAA;ACdN;ADkBE;EACE,oDAAA;AChBJ;ADmBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ACjBJ;ADmBI;EACE,eAAA;ACjBN;ADqBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;ACnBJ;ADsBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ACpBJ;ADuBE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,oCAAA;ACrBJ;ADwBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;ACtBJ;ADwBI;EACE,eAAA;ACtBN;ADvDA;EAiFE,kDAAA;ACvBF;ADwBE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;ACtBJ;ADwBI;EACE,oCAAA;EACA,mDAAA;ACtBN;ADyBI;EACE,qCAAA;EACA,oDAAA;ACvBN;AD0BI;EACE,qCAAA;EACA,oDAAA;ACxBN;AD2BI;EAEE,yCAAA;EACA,mDAAA;AC1BN;AD8BE;EACE,cAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;AC5BJ;AD+BE;EACE,yBAAA;AC7BJ;AD3FA;EA2HE,sEAAA;AC7BF;AD8BE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AC5BJ;AD8BI;EAPF;IAQI,gDAAA;EC3BJ;AACF;AD6BI;EAXF;IAYI,kBAAA;EC1BJ;AACF;AD6BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AC3BJ;AD6BI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AC3BN;AD8BI;EACE,OAAA;AC5BN;AD8BM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AC5BR;ADpIA;EAqKE,4EAAA;AC9BF;AD+BE;EACE;IACE,eAAA;EC7BJ;EDgCE;IACE,kDAAA;EC9BJ;EDiCE;IACE,QAAA;IACA,iBAAA;EC/BJ;AACF;;ADmCA;EACE,kBAAA;EACA,mBAAA;EACA,mDAAA;AChCF;ADkCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oCAAA;AChCJ;ADkCI;EACE,eAAA;EACA,+BAAA;AChCN;ADoCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AClCJ;;ADsCA,+BAAA;AAEE;EACE,uCAAA;ACpCJ;ADuCE;EACE,0CAAA;ACrCJ;ADwCE;EACE,yCAAA;ACtCJ;ADyCE;EACE,0CAAA;ACvCJ;AD0CE;EACE,yCAAA;ACxCJ;;AD4CA,mGAAA;AACA;EACE,wCAAA;EACA,uDAAA;EACA,mBAAA;EACA,0DAAA;EACA,6BAAA;ACzCF;AD2CE;EACE,UAAA;EACA,gCAAA;EACA,sDAAA;EACA,sBAAA;EACA,mBAAA;ACzCJ","sourcesContent":["/* Filters beside the list on wide screens, foldable panel above it on phones/tablets */\n.alarms-layout {\n  box-sizing: content-box;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px 12px 32px;\n\n  @media (min-width: 768px) {\n    padding: 24px 20px 40px;\n  }\n\n  @media (min-width: 992px) {\n    display: grid;\n    grid-template-columns: 300px minmax(0, 1fr);\n    align-items: start;\n    gap: 20px;\n  }\n}\n\n.alarms-results {\n  min-width: 0;\n}\n\n.alarms-filters {\n  margin-bottom: 16px;\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n\n  /* Phones/tablets: header button that folds the panel */\n  &__toggle {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 12px 16px;\n    border: 0;\n    border-radius: 14px;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n      outline-offset: -2px;\n    }\n  }\n\n  &__toggle-icon {\n    flex-shrink: 0;\n    font-size: 20px;\n    color: var(--ion-color-primary);\n  }\n\n  &__toggle-text {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__toggle-title {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  &__toggle-summary {\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__chevron {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-medium);\n    transition: transform 0.2s ease;\n  }\n\n  &--open &__chevron {\n    transform: rotate(180deg);\n  }\n\n  /* Title only in the side column */\n  &__title {\n    display: none;\n  }\n\n  &__body {\n    display: none;\n    padding: 4px 16px 16px;\n  }\n\n  &--open &__body {\n    display: block;\n  }\n\n  &__actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 16px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n\n    ion-button {\n      flex: 1;\n      margin: 0;\n      height: 42px;\n      --border-radius: 10px;\n      font-weight: 600;\n      text-transform: none;\n      letter-spacing: normal;\n    }\n  }\n\n  /* Wide screens: always open, sticky side column */\n  @media (min-width: 992px) {\n    position: sticky;\n    top: 16px;\n    margin-bottom: 0;\n    padding: 18px;\n\n    &__toggle {\n      display: none;\n    }\n\n    &__title {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin: 0 0 16px;\n      font-size: 17px;\n      font-weight: 600;\n\n      ion-icon {\n        font-size: 20px;\n        color: var(--ion-color-primary);\n      }\n    }\n\n    &__body {\n      display: block;\n      padding: 0;\n    }\n\n    // In the narrow column the filter fields stack\n    ::ng-deep .alarm-filters {\n      grid-template-columns: minmax(0, 1fr);\n    }\n\n    &__actions {\n      flex-direction: column-reverse;\n    }\n  }\n}\n\n/* Alarms: white rounded card, one row per alarm, details unfold below */\n.alarm-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n\n  @media (max-width: 767px) {\n    margin: 0 -12px;\n    border-radius: 0;\n    border-left: 0;\n    border-right: 0;\n  }\n}\n\n.alarm-item {\n  & + & {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n\n  &__head {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    width: 100%;\n    padding: 14px 16px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background: rgba(var(--ion-color-primary-rgb), 0.06);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n      outline-offset: -2px;\n    }\n  }\n\n  &--open &__head {\n    background: rgba(var(--ion-color-primary-rgb), 0.04);\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    color: #fff;\n\n    ion-icon {\n      font-size: 22px;\n    }\n  }\n\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__title {\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px 14px;\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n  }\n\n  &__meta-entry {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n\n    ion-icon {\n      font-size: 15px;\n    }\n  }\n\n  /* State pill: tinted version of the icon colour */\n  &__state {\n    flex-shrink: 0;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n\n    &.danger-background {\n      color: var(--ion-color-danger-shade);\n      background: rgba(var(--ion-color-danger-rgb), 0.12);\n    }\n\n    &.warning-background {\n      color: var(--ion-color-warning-shade);\n      background: rgba(var(--ion-color-warning-rgb), 0.16);\n    }\n\n    &.primary-background {\n      color: var(--ion-color-primary-shade);\n      background: rgba(var(--ion-color-primary-rgb), 0.12);\n    }\n\n    &.dark-background,\n    &.default-background {\n      color: var(--ion-color-step-750, #404040);\n      background: rgba(var(--ion-color-medium-rgb), 0.14);\n    }\n  }\n\n  &__chevron {\n    flex-shrink: 0;\n    font-size: 18px;\n    color: var(--ion-color-medium);\n    transition: transform 0.2s ease;\n  }\n\n  &--open &__chevron {\n    transform: rotate(180deg);\n  }\n\n  /* Expanded details: label/value pairs, side by side on wide screens */\n  &__details {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n    margin: 0;\n    padding: 4px 16px 16px 72px;\n\n    @media (min-width: 576px) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    @media (max-width: 575px) {\n      padding-left: 16px;\n    }\n  }\n\n  &--skeleton {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 14px 16px;\n\n    .skeleton-circle {\n      flex-shrink: 0;\n      width: 42px;\n      height: 42px;\n      margin: 0;\n      border-radius: 50%;\n    }\n\n    .skeleton-lines {\n      flex: 1;\n\n      ion-skeleton-text {\n        height: 12px;\n        margin: 6px 0;\n        border-radius: 6px;\n      }\n    }\n  }\n\n  /* Phones: the state pill moves under the text, to keep the title readable */\n  @media (max-width: 575px) {\n    &__head {\n      flex-wrap: wrap;\n    }\n\n    &__main {\n      flex-basis: calc(100% - 42px - 14px - 18px - 14px);\n    }\n\n    &__state {\n      order: 5;\n      margin-left: 56px;\n    }\n  }\n}\n\n.alarm-detail {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-medium-rgb), 0.07);\n\n  dt {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      font-size: 15px;\n      color: var(--ion-color-primary);\n    }\n  }\n\n  dd {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 500;\n    overflow-wrap: anywhere;\n  }\n}\n\n/* Icon colour by alarm state */\n.alarm-item__icon {\n  &.dark-background {\n    background-color: var(--ion-color-dark);\n  }\n\n  &.warning-background {\n    background-color: var(--ion-color-warning);\n  }\n\n  &.danger-background {\n    background-color: var(--ion-color-danger);\n  }\n\n  &.primary-background {\n    background-color: var(--ion-color-primary);\n  }\n\n  &.default-background {\n    background-color: var(--ion-color-medium);\n  }\n}\n\n/* \"Reset filters\": outlined when it can be used, faded and dashed when there is nothing to reset */\n.reset-button {\n  --color: var(--ion-color-step-800, #333);\n  --border-color: rgba(var(--ion-color-medium-rgb), 0.45);\n  --border-width: 1px;\n  --background-hover: rgba(var(--ion-color-medium-rgb), 0.1);\n  --background-hover-opacity: 1;\n\n  &.button-disabled {\n    opacity: 1;\n    --color: var(--ion-color-medium);\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.3);\n    --border-style: dashed;\n    cursor: not-allowed;\n  }\n}\n","/* Filters beside the list on wide screens, foldable panel above it on phones/tablets */\n.alarms-layout {\n  box-sizing: content-box;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 16px 12px 32px;\n}\n@media (min-width: 768px) {\n  .alarms-layout {\n    padding: 24px 20px 40px;\n  }\n}\n@media (min-width: 992px) {\n  .alarms-layout {\n    display: grid;\n    grid-template-columns: 300px minmax(0, 1fr);\n    align-items: start;\n    gap: 20px;\n  }\n}\n\n.alarms-results {\n  min-width: 0;\n}\n\n.alarms-filters {\n  margin-bottom: 16px;\n  border-radius: 14px;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n  /* Phones/tablets: header button that folds the panel */\n}\n.alarms-filters__toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  border: 0;\n  border-radius: 14px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.alarms-filters__toggle:focus-visible {\n  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n  outline-offset: -2px;\n}\n.alarms-filters__toggle-icon {\n  flex-shrink: 0;\n  font-size: 20px;\n  color: var(--ion-color-primary);\n}\n.alarms-filters__toggle-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n.alarms-filters__toggle-title {\n  font-size: 15px;\n  font-weight: 600;\n}\n.alarms-filters__toggle-summary {\n  font-size: 13px;\n  color: var(--ion-color-medium-shade);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.alarms-filters__chevron {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: var(--ion-color-medium);\n  transition: transform 0.2s ease;\n}\n.alarms-filters--open .alarms-filters__chevron {\n  transform: rotate(180deg);\n}\n.alarms-filters {\n  /* Title only in the side column */\n}\n.alarms-filters__title {\n  display: none;\n}\n.alarms-filters__body {\n  display: none;\n  padding: 4px 16px 16px;\n}\n.alarms-filters--open .alarms-filters__body {\n  display: block;\n}\n.alarms-filters__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.15);\n}\n.alarms-filters__actions ion-button {\n  flex: 1;\n  margin: 0;\n  height: 42px;\n  --border-radius: 10px;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.alarms-filters {\n  /* Wide screens: always open, sticky side column */\n}\n@media (min-width: 992px) {\n  .alarms-filters {\n    position: sticky;\n    top: 16px;\n    margin-bottom: 0;\n    padding: 18px;\n  }\n  .alarms-filters__toggle {\n    display: none;\n  }\n  .alarms-filters__title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 16px;\n    font-size: 17px;\n    font-weight: 600;\n  }\n  .alarms-filters__title ion-icon {\n    font-size: 20px;\n    color: var(--ion-color-primary);\n  }\n  .alarms-filters__body {\n    display: block;\n    padding: 0;\n  }\n  .alarms-filters ::ng-deep .alarm-filters {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .alarms-filters__actions {\n    flex-direction: column-reverse;\n  }\n}\n\n/* Alarms: white rounded card, one row per alarm, details unfold below */\n.alarm-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n}\n@media (max-width: 767px) {\n  .alarm-list {\n    margin: 0 -12px;\n    border-radius: 0;\n    border-left: 0;\n    border-right: 0;\n  }\n}\n\n.alarm-item + .alarm-item {\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n}\n.alarm-item__head {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  padding: 14px 16px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n.alarm-item__head:hover {\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n.alarm-item__head:focus-visible {\n  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n  outline-offset: -2px;\n}\n.alarm-item--open .alarm-item__head {\n  background: rgba(var(--ion-color-primary-rgb), 0.04);\n}\n.alarm-item__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  color: #fff;\n}\n.alarm-item__icon ion-icon {\n  font-size: 22px;\n}\n.alarm-item__main {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n.alarm-item__title {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n.alarm-item__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 14px;\n  font-size: 13px;\n  color: var(--ion-color-medium-shade);\n}\n.alarm-item__meta-entry {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.alarm-item__meta-entry ion-icon {\n  font-size: 15px;\n}\n.alarm-item {\n  /* State pill: tinted version of the icon colour */\n}\n.alarm-item__state {\n  flex-shrink: 0;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.alarm-item__state.danger-background {\n  color: var(--ion-color-danger-shade);\n  background: rgba(var(--ion-color-danger-rgb), 0.12);\n}\n.alarm-item__state.warning-background {\n  color: var(--ion-color-warning-shade);\n  background: rgba(var(--ion-color-warning-rgb), 0.16);\n}\n.alarm-item__state.primary-background {\n  color: var(--ion-color-primary-shade);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n.alarm-item__state.dark-background, .alarm-item__state.default-background {\n  color: var(--ion-color-step-750, #404040);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n.alarm-item__chevron {\n  flex-shrink: 0;\n  font-size: 18px;\n  color: var(--ion-color-medium);\n  transition: transform 0.2s ease;\n}\n.alarm-item--open .alarm-item__chevron {\n  transform: rotate(180deg);\n}\n.alarm-item {\n  /* Expanded details: label/value pairs, side by side on wide screens */\n}\n.alarm-item__details {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 10px;\n  margin: 0;\n  padding: 4px 16px 16px 72px;\n}\n@media (min-width: 576px) {\n  .alarm-item__details {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (max-width: 575px) {\n  .alarm-item__details {\n    padding-left: 16px;\n  }\n}\n.alarm-item--skeleton {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 16px;\n}\n.alarm-item--skeleton .skeleton-circle {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  margin: 0;\n  border-radius: 50%;\n}\n.alarm-item--skeleton .skeleton-lines {\n  flex: 1;\n}\n.alarm-item--skeleton .skeleton-lines ion-skeleton-text {\n  height: 12px;\n  margin: 6px 0;\n  border-radius: 6px;\n}\n.alarm-item {\n  /* Phones: the state pill moves under the text, to keep the title readable */\n}\n@media (max-width: 575px) {\n  .alarm-item__head {\n    flex-wrap: wrap;\n  }\n  .alarm-item__main {\n    flex-basis: calc(100% - 42px - 14px - 18px - 14px);\n  }\n  .alarm-item__state {\n    order: 5;\n    margin-left: 56px;\n  }\n}\n\n.alarm-detail {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(var(--ion-color-medium-rgb), 0.07);\n}\n.alarm-detail dt {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  color: var(--ion-color-medium-shade);\n}\n.alarm-detail dt ion-icon {\n  font-size: 15px;\n  color: var(--ion-color-primary);\n}\n.alarm-detail dd {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  overflow-wrap: anywhere;\n}\n\n/* Icon colour by alarm state */\n.alarm-item__icon.dark-background {\n  background-color: var(--ion-color-dark);\n}\n.alarm-item__icon.warning-background {\n  background-color: var(--ion-color-warning);\n}\n.alarm-item__icon.danger-background {\n  background-color: var(--ion-color-danger);\n}\n.alarm-item__icon.primary-background {\n  background-color: var(--ion-color-primary);\n}\n.alarm-item__icon.default-background {\n  background-color: var(--ion-color-medium);\n}\n\n/* \"Reset filters\": outlined when it can be used, faded and dashed when there is nothing to reset */\n.reset-button {\n  --color: var(--ion-color-step-800, #333);\n  --border-color: rgba(var(--ion-color-medium-rgb), 0.45);\n  --border-width: 1px;\n  --background-hover: rgba(var(--ion-color-medium-rgb), 0.1);\n  --background-hover-opacity: 1;\n}\n.reset-button.button-disabled {\n  opacity: 1;\n  --color: var(--ion-color-medium);\n  --border-color: rgba(var(--ion-color-medium-rgb), 0.3);\n  --border-style: dashed;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
